import { AsyncReturnType } from "type-fest";

import { CrmService } from "@/services/crm-service";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CrmService.createLead>[0];
type Data = AsyncReturnType<typeof CrmService.createLead>;
type Error = unknown;

export const useCreateLead = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CrmService.createLead,
    options
  );

  return result;
};
